import { Cell, Icon, Row } from '@dexma/ui-components';
import { ConfigFieldType, ChartLimitValue } from 'adapter/in/common/form/types';
import ColorPickerInputContainer from 'adapter/in/common/form/ColorPicker';
import TextInputContainer from 'adapter/in/common/form/Text';
import { OPTIONS } from 'adapter/in/common/widget/options';
import {
    StyledCellRangeGroupContainer,
    StyledRemoveRangeButton,
} from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Options/Range/style';
import { RemoveElementRHF } from 'adapter/in/common/hooks/useArrayField';
import { validationIsNumber } from 'adapter/in/common/utils/validation';
import i18n from 'asset/translation';
import React, { memo } from 'react';

type ChartLimitGroupContainerProps = {
    item: ChartLimitValue & { id: string };
    index: number;
    handleRemoveLimit: (index?: RemoveElementRHF) => void;
};

const ChartLimitGroupContainer = memo((props: ChartLimitGroupContainerProps) => {
    const { index, item, handleRemoveLimit } = props;
    return (
        <StyledCellRangeGroupContainer key={item.id}>
            <StyledRemoveRangeButton>
                <Cell onClick={() => handleRemoveLimit(index)}>
                    <Icon name='add' ariaLabel={i18n.t('widgets.widgetMenu.checkpoints.removeLimitAriaLabel')} />
                </Cell>
            </StyledRemoveRangeButton>
            <Row>
                <ColorPickerInputContainer
                    showInput={false}
                    configType={ConfigFieldType.OPTIONS}
                    name={`${OPTIONS.CHECKPOINTS}.${index}.color`}
                    label=''
                    dataDependsOn={[]}
                    defaultValue={item.color}
                />
                <Cell>
                    <TextInputContainer
                        configType={ConfigFieldType.OPTIONS}
                        name={`${OPTIONS.CHECKPOINTS}.${index}.name`}
                        label={i18n.t('widgets.widgetMenu.checkpoints.name')}
                        properties={{ maxLength: 100, placeholder: '' }}
                        footer=''
                        dataDependsOn={[]}
                        defaultValue={item.name}
                    />
                </Cell>
                <Cell>
                    <TextInputContainer
                        configType={ConfigFieldType.OPTIONS}
                        name={`${OPTIONS.CHECKPOINTS}.${index}.value`}
                        label={i18n.t('widgets.widgetMenu.checkpoints.value')}
                        properties={{ maxLength: 100, placeholder: '' }}
                        footer=''
                        dataDependsOn={[]}
                        defaultValue={item.value}
                        rules={{
                            required: true,
                            validate: {
                                isNumber: validationIsNumber,
                            },
                        }}
                    />
                </Cell>
            </Row>
        </StyledCellRangeGroupContainer>
    );
});

export default ChartLimitGroupContainer;
